import React from "react";
import JurisdictionsView from "../../../views/dashboard/jurisdictions";

const Jurisdictions = () => {
  return <JurisdictionsView />;
};

export default Jurisdictions;
